import { ApolloClient, gql } from '@apollo/client';
import { DocumentCommentPayloadType } from '../../../components/document-wizard/document.types';
import { transformCommentsPayload } from '../../transform-comments-payload/transform-comments-payload.util';

const query = gql`
  fragment DocumentCommentFields on CkeDocumentComment {
    id
    attributes
    authorId
    authorName
    commentId
    content
    createdAt
    isPublic
    threadId
    updatedAt
  }

  query getDocumentCommentsByDocument($documentId: ID!, $threadId: String) {
    getDocumentCommentsByDocument(documentId: $documentId, threadId: $threadId) {
      attributes
      comments {
        ...DocumentCommentFields
      }
      resolvedBy
      resolvedAt
      threadId
    }
  }
`;

export const getCommentsForLeaseDocument =
  (documentId: string, threadId: string) =>
  (client: ApolloClient<object>): Promise<any> => {
    const variables = {
      documentId,
      threadId,
    };

    return client.query({ query, variables }).then(({ data }: Record<any, any>) => {
      const comments: DocumentCommentPayloadType[] = data.getDocumentCommentsByDocument;
      return transformCommentsPayload(comments);
    });
  };

export const getCommentsForLeaseDocumentSection =
  (documentId: string, threadId: string, fetchPolicy?: 'cache-first' | 'network-only') =>
  (client: ApolloClient<object>): Promise<any> => {
    const variables = {
      documentId,
      threadId,
    };

    // Callers that RESTORE state (docx-native private comments) must pass
    // 'network-only'. Comments are written through a mutation that doesn't
    // update this query's cache entry, so the default cache-first hands back
    // the list as it was when the document first opened — missing everything
    // added since, which reads as "my comment disappeared".
    return client
      .query({ query, variables, ...(fetchPolicy ? { fetchPolicy } : {}) })
      .then(({ data }: Record<any, any>) => {
        return data.getDocumentCommentsByDocument;
      });
  };
